var map = {
	"./book_icon.svg": 27685,
	"./briefcase_icon.svg": 27664,
	"./briefcase_icon_2.svg": 181,
	"./check_icon.svg": 63805,
	"./close_menu_mobile.svg": 88907,
	"./computer_icon.svg": 6281,
	"./contract_icon.svg": 36390,
	"./cpd_modules.svg": 12232,
	"./deleted_icon.svg": 72291,
	"./document_icon.svg": 35758,
	"./email_icon.svg": 50791,
	"./email_icon_blue.svg": 28559,
	"./email_storage_icon.svg": 95432,
	"./exempt_icon.svg": 33451,
	"./gdpr_stripping_icon.svg": 75941,
	"./headphones_icon.svg": 50810,
	"./home_icon.svg": 64512,
	"./itc_logo.svg": 40644,
	"./laptop_icon.svg": 87338,
	"./lightbulb_icon.svg": 12764,
	"./menu_mobile.svg": 88350,
	"./mystery_shop_icon.svg": 77401,
	"./online_training_icon.svg": 31523,
	"./phone_icon.svg": 41361,
	"./profile_icon.svg": 36244,
	"./regulatory_icon.svg": 3441,
	"./right_arrow.svg": 84938,
	"./scan_or_photograph_icon.svg": 15228,
	"./scroll_arrow_blue.svg": 39895,
	"./scroller_ar.svg": 41846,
	"./scroller_communication.svg": 23245,
	"./scroller_deal_file.svg": 63719,
	"./scroller_learning.svg": 96600,
	"./scroller_licence_check.svg": 87641,
	"./scroller_vr.svg": 64915,
	"./shield_icon.svg": 43084,
	"./smcr_icon.svg": 92356,
	"./smcr_training_icon.svg": 3706,
	"./star_icon.svg": 24037
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92498;